function csvDataToJSON(data, parentId) {
    data = data.split(/\n/);
    const headers = data[0].split(/\t/);
    const jsonData = {};
  
    data.forEach((product, index) => {
      if (index === 0) {
        return; //ignore headers
      } else {
        const splitProduct = product.split(/\t/);
        jsonData[splitProduct[parentId]] = {}; //ID
        headers.forEach((header, index) => {
          jsonData[splitProduct[parentId]][header] = splitProduct[index];
        });
      }
    });
  
    return jsonData;
  }
  
  module.exports = csvDataToJSON;
  